const commons = {
    basePath: '/categories',
    singular: 'categorie',
    plural: 'categories',
}

export default  commons